/* CADS trilingual dictionary (RU / KZ / EN) */

export const LANGS = ["ru", "kz", "en"];
export const LANG_LABELS = { ru: "РУ", kz: "ҚАЗ", en: "EN" };
export const LANG_STORAGE_KEY = "cads_lang";

export const dictionary = {
  meta: {
    company_short: "CADS",
    company_full_ru: "ТОО «Central Asia Digital Solutions»",
    company_full_kz: "«Central Asia Digital Solutions» ЖШС",
    company_full_en: "Central Asia Digital Solutions LLP",
  },
  nav: {
    ru: [
      { id: "about", label: "Главная" },
      { id: "advantages", label: "Преимущества" },
      { id: "products", label: "Продукты" },
      { id: "import", label: "Импорт и таможня" },
      { id: "contacts", label: "Контакты" },
      { id: "form", label: "Заявка" },
    ],
    kz: [
      { id: "about", label: "Басты" },
      { id: "advantages", label: "Артықшылықтар" },
      { id: "products", label: "Өнімдер" },
      { id: "import", label: "Импорт және кеден" },
      { id: "contacts", label: "Байланыс" },
      { id: "form", label: "Сұраныс" },
    ],
    en: [
      { id: "about", label: "Home" },
      { id: "advantages", label: "Advantages" },
      { id: "products", label: "Products" },
      { id: "import", label: "Import & Customs" },
      { id: "contacts", label: "Contacts" },
      { id: "form", label: "Request" },
    ],
    cta: {
      ru: "Получить IT-подбор",
      kz: "IT-шешім алу",
      en: "Get IT consult",
    },
  },
  hero: {
    badge: {
      ru: "СИСТЕМНАЯ ИНТЕГРАЦИЯ · ЦЕНТРАЛЬНАЯ АЗИЯ",
      kz: "ЖҮЙЕЛІК ИНТЕГРАЦИЯ · ОРТАЛЫҚ АЗИЯ",
      en: "SYSTEMS INTEGRATION · CENTRAL ASIA",
    },
    title_top: {
      ru: "Цифровая трансформация",
      kz: "Бизнесіңіздің",
      en: "Digital transformation",
    },
    title_bottom: {
      ru: "вашего бизнеса",
      kz: "сандық трансформациясы",
      en: "of your business",
    },
    subtitle: {
      ru: "Central Asia Digital Solutions — ваш технологический партнер: проектируем, поставляем и сопровождаем IT-инфраструктуру корпоративного класса в Казахстане и Центральной Азии.",
      kz: "Central Asia Digital Solutions — сіздің технологиялық серіктесіңіз: Қазақстан мен Орталық Азияда корпоративтік деңгейдегі IT-инфрақұрылымды жобалаймыз, жеткіземіз және сүйемелдейміз.",
      en: "Central Asia Digital Solutions is your technology partner — we design, supply, and support enterprise-grade IT infrastructure across Kazakhstan and Central Asia.",
    },
    primary_cta: {
      ru: "Получить IT-подбор",
      kz: "IT-шешім алу",
      en: "Get IT consult",
    },
    secondary_cta: { ru: "Наши продукты", kz: "Біздің өнімдер", en: "Our products" },
    stats: [
      {
        value: "24 / 7",
        label: {
          ru: "Техническая поддержка",
          kz: "Техникалық қолдау",
          en: "Technical support",
        },
      },
      {
        value: "SLA",
        label: {
          ru: "Гарантия надежности",
          kz: "Сенімділік кепілдігі",
          en: "Reliability guarantee",
        },
      },
      {
        value: "KZ",
        label: {
          ru: "Локальная экспертиза",
          kz: "Жергілікті сараптама",
          en: "Local expertise",
        },
      },
    ],
  },
  about: {
    label: { ru: "О КОМПАНИИ", kz: "КОМПАНИЯ ТУРАЛЫ", en: "ABOUT THE COMPANY" },
    title: {
      ru: "Технологический партнер для бизнеса",
      kz: "Бизнес үшін технологиялық серіктес",
      en: "A technology partner for business",
    },
    paragraphs: {
      ru: [
        "Central Asia Digital Solutions (CADS) — ваш технологический партнер в цифровой трансформации бизнеса в Центральной Азии.",
        "Мы создаем и внедряем IT-решения полного цикла: от поставки серверного и сетевого оборудования до разработки программного обеспечения, системной интеграции и кибербезопасности. Работаем с ведущими мировыми брендами.",
        "Наш подход — это не просто поставка технологий, а построение устойчивой IT-инфраструктуры, которая помогает бизнесу расти, масштабироваться и быть защищенным.",
        "CADS сопровождает проекты на всех этапах: анализ, проектирование, внедрение и дальнейшая техническая поддержка.",
      ],
      kz: [
        "Central Asia Digital Solutions (CADS) — Орталық Азиядағы бизнестің сандық трансформациясындағы сіздің технологиялық серіктесіңіз.",
        "Біз толық циклді IT-шешімдерді жасап, енгіземіз: серверлік және желілік жабдықты жеткізуден бастап, бағдарламалық қамтамасыз етуді әзірлеу, жүйелік интеграция және киберқауіпсіздікке дейін. Әлемдегі жетекші брендтермен жұмыс істейміз.",
        "Біздің тәсіліміз — тек технологияларды жеткізу ғана емес, бизнестің өсуіне, масштабталуына және қорғалуына көмектесетін тұрақты IT-инфрақұрылым құру.",
        "CADS жобаларды барлық кезеңде сүйемелдейді: талдау, жобалау, енгізу және одан кейінгі техникалық қолдау.",
      ],
      en: [
        "Central Asia Digital Solutions (CADS) is your technology partner in the digital transformation of business across Central Asia.",
        "We design and deploy full-cycle IT solutions — from server and network equipment to software development, systems integration, and cybersecurity. We work with the world's leading brands.",
        "Our approach is not just supplying technology, but building resilient IT infrastructure that helps business grow, scale, and stay secure.",
        "CADS supports projects at every stage: analysis, design, implementation, and ongoing technical support.",
      ],
    },
  },
  advantages: {
    label: {
      ru: "ПРЕИМУЩЕСТВА СОТРУДНИЧЕСТВА",
      kz: "ЫНТЫМАҚТАСТЫҚ АРТЫҚШЫЛЫҚТАРЫ",
      en: "PARTNERSHIP ADVANTAGES",
    },
    title: {
      ru: "Шесть причин работать с CADS",
      kz: "CADS-пен жұмыс істеудің алты себебі",
      en: "Six reasons to work with CADS",
    },
    items: [
      {
        icon: "Award",
        title: { ru: "Экспертный подход", kz: "Сараптамалық тәсіл", en: "Expert approach" },
        desc: {
          ru: "Работаем с решениями IBM, Dell, Fortinet, Cisco и подбираем оптимальные конфигурации под задачи клиента.",
          kz: "IBM, Dell, Fortinet, Cisco шешімдерімен жұмыс істеп, клиент тапсырмалары үшін оңтайлы конфигурацияларды таңдаймыз.",
          en: "We work with IBM, Dell, Fortinet, Cisco solutions and select optimal configurations for each client's tasks.",
        },
      },
      {
        icon: "TrendingDown",
        title: { ru: "Снижение затрат", kz: "Шығынды азайту", en: "Cost reduction" },
        desc: {
          ru: "Прямые партнерские поставки без посредников гарантируют конкурентную стоимость.",
          kz: "Делдалсыз тікелей серіктестік жеткізілім бәсекеге қабілетті бағаға кепілдік береді.",
          en: "Direct partner supplies with no middlemen guarantee competitive pricing.",
        },
      },
      {
        icon: "Settings2",
        title: { ru: "Индивидуальность", kz: "Жеке тәсіл", en: "Tailored configurations" },
        desc: {
          ru: "Гибкий подбор конфигураций под рамки бюджета и масштабы бизнеса.",
          kz: "Бюджет шегіне және бизнес ауқымына сәйкес икемді конфигурацияларды таңдау.",
          en: "Flexible configurations fit your budget and business scale.",
        },
      },
      {
        icon: "Workflow",
        title: { ru: "Полный цикл", kz: "Толық цикл", en: "End-to-end cycle" },
        desc: {
          ru: "Поставка, доставка, монтаж, пусконаладка и сопровождение в рамках одного договора.",
          kz: "Жеткізу, монтаждау, іске қосу және сүйемелдеу — бір келісімшарт аясында.",
          en: "Supply, delivery, installation, commissioning, and support — under one contract.",
        },
      },
      {
        icon: "ShieldCheck",
        title: { ru: "Гарантия вендора", kz: "Вендор кепілдігі", en: "Vendor warranty" },
        desc: {
          ru: "Официальная техническая поддержка и гарантийное обслуживание от производителя.",
          kz: "Өндірушіден ресми техникалық қолдау және кепілдік қызметі.",
          en: "Official manufacturer technical support and warranty service.",
        },
      },
      {
        icon: "Target",
        title: { ru: "Фокус на результат", kz: "Нәтижеге бағдар", en: "Focus on results" },
        desc: {
          ru: "Ориентируемся на высокие показатели отказоустойчивости систем клиентов.",
          kz: "Клиент жүйелерінің жоғары қателіктерге төзімділік көрсеткіштеріне назар аударамыз.",
          en: "We aim for the highest fault-tolerance of customer systems.",
        },
      },
    ],
  },
  products: {
    label: { ru: "НАШИ ПРОДУКТЫ", kz: "БІЗДІҢ ӨНІМДЕР", en: "OUR PRODUCTS" },
    title: {
      ru: "Решения от ведущих мировых брендов",
      kz: "Әлемдік жетекші брендтердің шешімдері",
      en: "Solutions from leading global brands",
    },
    subtitle: {
      ru: "Подбираем оборудование и лицензионное ПО под задачи заказчика — от вычислительных платформ до информационной безопасности.",
      kz: "Тапсырыс берушінің мақсаттарына сай жабдық пен лицензиялық бағдарламалық қамтамасыз етуді таңдаймыз — есептеу платформаларынан ақпараттық қауіпсіздікке дейін.",
      en: "We tailor equipment and licensed software to your goals — from compute platforms to information security.",
    },
    items: [
      {
        icon: "Server",
        title: { ru: "Серверы", kz: "Серверлер", en: "Servers" },
        vendors: ["IBM Power", "Dell PowerEdge", "HP ProLiant", "Lenovo"],
      },
      {
        icon: "HardDrive",
        title: {
          ru: "Системы хранения данных (СХД)",
          kz: "Деректерді сақтау жүйелері (СХД)",
          en: "Storage systems",
        },
        vendors: ["Dell EMC", "IBM", "NetApp", "OceanStor"],
      },
      {
        icon: "Cpu",
        title: { ru: "Процессоры", kz: "Процессорлар", en: "Processors" },
        vendors: ["Intel Xeon", "AMD EPYC"],
      },
      {
        icon: "Lock",
        title: {
          ru: "Информационная безопасность",
          kz: "Ақпараттық қауіпсіздік",
          en: "Information security",
        },
        vendors: ["Fortinet FortiGate", "Cisco ASA", "CheckPoint"],
      },
      {
        icon: "Phone",
        title: {
          ru: "Корпоративная телефония",
          kz: "Корпоративтік телефония",
          en: "Enterprise telephony",
        },
        vendors: ["Cisco", "Huawei"],
      },
      {
        icon: "Network",
        title: {
          ru: "Сети передачи данных",
          kz: "Деректерді тарату желілері",
          en: "Networking",
        },
        vendors: ["Cisco", "Juniper", "Aruba"],
      },
      {
        icon: "BatteryCharging",
        title: {
          ru: "Источники бесперебойного питания",
          kz: "Үздіксіз қуат көздері",
          en: "Uninterruptible power supplies",
        },
        vendors: ["APC", "Eaton"],
      },
      {
        icon: "FileCode",
        title: {
          ru: "Лицензионное программное обеспечение",
          kz: "Лицензиялық бағдарламалық қамтамасыз ету",
          en: "Licensed software",
        },
        vendors: ["Microsoft", "Kaspersky", "Adobe", "AutoCAD"],
      },
    ],
  },
  importSection: {
    label: {
      ru: "ПРЯМОЙ ИМПОРТ И ТАМОЖЕННОЕ СОПРОВОЖДЕНИЕ",
      kz: "ТІКЕЛЕЙ ИМПОРТ ЖӘНЕ КЕДЕНДІК СҮЙЕМЕЛДЕУ",
      en: "DIRECT IMPORT & CUSTOMS",
    },
    title: {
      ru: "Прозрачные поставки IT-оборудования по всему Казахстану и Центральной Азии",
      kz: "Бүкіл Қазақстан мен Орталық Азия бойынша IT-жабдықтың ашық жеткізілімі",
      en: "Transparent IT-equipment supply across Kazakhstan and Central Asia",
    },
    intro: {
      ru: "Мы обеспечиваем прозрачные и безопасные поставки IT-оборудования для государственных организаций, квазигосударственного сектора и коммерческих компаний.",
      kz: "Біз мемлекеттік ұйымдарға, квазимемлекеттік сектор мен коммерциялық компанияларға IT-жабдықтың ашық әрі қауіпсіз жеткізілімін қамтамасыз етеміз.",
      en: "We deliver transparent and secure IT-equipment supplies to government, quasi-government, and commercial organizations.",
    },
    items: [
      {
        icon: "PackageCheck",
        title: {
          ru: "Прямой импорт и таможенное оформление",
          kz: "Тікелей импорт және кедендік ресімдеу",
          en: "Direct import & customs clearance",
        },
        desc: {
          ru: "Поставляем оборудование напрямую от ведущих мировых производителей. Все поставки проходят официальное таможенное оформление и сопровождаются полным комплектом документов, подтверждающих легальность ввоза и происхождение продукции.",
          kz: "Жабдықты әлемдік жетекші өндірушілерден тікелей жеткіземіз. Барлық жеткізілімдер ресми кедендік ресімдеуден өтіп, әкелудің заңдылығын және өнімнің шығу тегін растайтын құжаттардың толық жиынтығымен сүйемелденеді.",
          en: "We supply equipment directly from leading global manufacturers. Every shipment is officially cleared through customs and accompanied by a full set of documents confirming the legality of import and origin of the product.",
        },
      },
      {
        icon: "BadgeCheck",
        title: {
          ru: "Официальная гарантия производителей",
          kz: "Өндірушілердің ресми кепілдігі",
          en: "Official manufacturer warranty",
        },
        desc: {
          ru: "На поставляемое оборудование распространяются официальные гарантийные обязательства производителей. Мы обеспечиваем доступ к сервисной поддержке и гарантийному обслуживанию в соответствии со стандартами вендоров — включая IBM, Dell Technologies, Cisco и других.",
          kz: "Жеткізілетін жабдыққа өндірушілердің ресми кепілдік міндеттемелері қолданылады. Біз вендор стандарттарына сәйкес сервистік қолдау мен кепілдік қызметке қол жеткізуді қамтамасыз етеміз — IBM, Dell Technologies, Cisco және басқаларды қоса алғанда.",
          en: "All equipment is covered by official manufacturer warranties. We provide access to service support and warranty service in line with vendor standards — including IBM, Dell Technologies, Cisco, and others.",
        },
      },
      {
        icon: "FileSignature",
        title: {
          ru: "Полное тендерное сопровождение",
          kz: "Толық тендерлік сүйемелдеу",
          en: "Full tender support",
        },
        desc: {
          ru: "Работаем в рамках государственных закупок, коммерческих тендеров и прямых контрактов. Подготавливаем полный комплект договорной и бухгалтерской документации, обеспечивая соответствие требованиям законодательства Республики Казахстан и внутренним процедурам заказчика.",
          kz: "Мемлекеттік сатып алу, коммерциялық тендерлер және тікелей келісімшарттар аясында жұмыс істейміз. Қазақстан Республикасының заңнамасы мен тапсырыс берушінің ішкі рәсімдеріне сәйкестікті қамтамасыз ете отырып, келісімшарттық және бухгалтерлік құжаттаманың толық жиынтығын дайындаймыз.",
          en: "We operate within state procurement, commercial tenders, and direct contracts. We prepare a complete set of contractual and accounting documents, ensuring compliance with the legislation of the Republic of Kazakhstan and the customer's internal procedures.",
        },
      },
    ],
  },
  contacts: {
    label: { ru: "КОНТАКТЫ", kz: "БАЙЛАНЫС", en: "CONTACTS" },
    title: { ru: "Наши контакты", kz: "Біздің байланыс", en: "Get in touch" },
    address_label: { ru: "Адрес", kz: "Мекенжай", en: "Address" },
    address_value_ru: "г. Алматы, ул. Байзакова, дом 280, 6 этаж",
    address_value_kz: "Алматы қаласы, Байзақов көшесі, 280-үй, 6-қабат",
    address_value_en: "Almaty, Baizakov Street, Building 280, 6th Floor",
    phone_label: { ru: "Телефон", kz: "Телефон", en: "Phone" },
    phone_value: "+7 702 366 97 48",
    email_label: { ru: "Email", kz: "Email", en: "Email" },
    email_value: "info@c-ads.kz",
    hours_label: { ru: "Часы работы", kz: "Жұмыс уақыты", en: "Working hours" },
    hours_value: {
      ru: "Пн – Пт · 09:00 – 18:00",
      kz: "Дс – Жм · 09:00 – 18:00",
      en: "Mon – Fri · 09:00 – 18:00",
    },
    map_caption: {
      ru: "Алматы · ул. Байзакова 280, 6 этаж",
      kz: "Алматы · Байзақов көш. 280-үй, 6-қабат",
      en: "Almaty · Baizakov Street 280, 6th Floor",
    },
  },
  form: {
    label: {
      ru: "ЗАПОЛНИ ФОРМУ И ПОЛУЧИ ОТВЕТ",
      kz: "ФОРМАНЫ ТОЛТЫРЫҢЫЗ ЖӘНЕ ЖАУАП АЛЫҢЫЗ",
      en: "FILL THE FORM AND GET A REPLY",
    },
    title: {
      ru: "Получите персональный IT-подбор",
      kz: "Жеке IT-шешімді алыңыз",
      en: "Get a personal IT consult",
    },
    subtitle: {
      ru: "Опишите задачу или интересующее оборудование — мы свяжемся с вами в течение рабочего дня и подготовим коммерческое предложение.",
      kz: "Тапсырманы немесе қызықтыратын жабдықты сипаттаңыз — біз сізбен бір жұмыс күні ішінде хабарласып, коммерциялық ұсыныс дайындаймыз.",
      en: "Describe your task or the equipment you need — our manager will get back to you within one business day with a quote.",
    },
    fields: {
      email: { ru: "Ваш Email", kz: "Сіздің Email", en: "Your Email" },
      name: { ru: "Ваше имя", kz: "Сіздің атыңыз", en: "Your Name" },
      message: {
        ru: "Запрос — какое оборудование или задачи вас интересуют",
        kz: "Сұраныс — қандай жабдық немесе тапсырмалар қызықтырады",
        en: "Request — equipment or tasks you are interested in",
      },
      company: { ru: "Название компании", kz: "Компания атауы", en: "Company name" },
    },
    submit: {
      ru: "Получить IT-подбор",
      kz: "IT-шешім алу",
      en: "Get IT consult",
    },
    sending: { ru: "Отправка…", kz: "Жіберілуде…", en: "Sending…" },
    success: {
      ru: "Заявка отправлена. Менеджер свяжется с вами в ближайшее время.",
      kz: "Сұраныс жіберілді. Менеджер сізбен жақын арада хабарласады.",
      en: "Request sent. Our manager will contact you shortly.",
    },
    error: {
      ru: "Не удалось отправить заявку. Попробуйте ещё раз.",
      kz: "Сұранысты жіберу мүмкін болмады. Қайталап көріңіз.",
      en: "Could not send the request. Please try again.",
    },
    required: {
      ru: "Заполните Email, имя и описание запроса.",
      kz: "Email, атыңыз және сұраныс сипаттамасын толтырыңыз.",
      en: "Please fill in Email, Name and the request description.",
    },
    privacy: {
      ru: "Отправляя форму, вы соглашаетесь на обработку персональных данных.",
      kz: "Форманы жіберу арқылы сіз дербес деректерді өңдеуге келісім бересіз.",
      en: "By submitting, you agree to the processing of your personal data.",
    },
    perk: {
      ru: "Менеджер CADS подготовит индивидуальный подбор оборудования и коммерческое предложение в течение одного рабочего дня.",
      kz: "CADS менеджері бір жұмыс күні ішінде жабдықтың жеке таңдауын және коммерциялық ұсыныс дайындайды.",
      en: "A CADS manager will prepare a tailored equipment list and quote within one business day.",
    },
  },
  footer: {
    tagline: {
      ru: "Комплексная системная интеграция, прямой импорт и поставки IT-оборудования в Республике Казахстан и Центральной Азии.",
      kz: "Қазақстан Республикасы мен Орталық Азияда кешенді жүйелік интеграция, тікелей импорт және IT-жабдықты жеткізу.",
      en: "Comprehensive systems integration, direct import, and IT-equipment supply across Kazakhstan and Central Asia.",
    },
    rights: {
      ru: "Все права защищены.",
      kz: "Барлық құқықтар қорғалған.",
      en: "All rights reserved.",
    },
    nav_title: { ru: "Навигация", kz: "Навигация", en: "Navigation" },
    contact_title: { ru: "Контакты", kz: "Байланыс", en: "Contacts" },
  },
};
